import { library } from '@fortawesome/fontawesome-svg-core'

import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faTrafficCone } from '@fortawesome/pro-solid-svg-icons/faTrafficCone'
import { faCalendarDay } from '@fortawesome/pro-solid-svg-icons/faCalendarDay'
import { faFolders } from '@fortawesome/pro-solid-svg-icons/faFolders'
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy'
import { faTags } from '@fortawesome/pro-solid-svg-icons/faTags'
import { faCloud } from '@fortawesome/pro-solid-svg-icons/faCloud'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faFileInvoice } from '@fortawesome/pro-solid-svg-icons/faFileInvoice'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog'

library.add(
  faTimes, faTrafficCone, faCalendarDay, faFolders, faCopy, faTags, faCloud, faChevronLeft, faChevronRight, faCheck,
  faBan, faEnvelope, faFileInvoice, faUsers, faCog
)
